import {
  JSONApiRelation,
  JSONApiRelationList,
  JSONApiResourceBase,
} from '../interfaces/JSONApi.js'

export enum QueueType {
  Inbound = 'Inbound',
  Outbound = 'Outbound',
}

export interface QueueFlows {
  inboundFlow: { steps: unknown[] }
  outboundFlow: { steps: unknown[] }
}

export enum CLIDCycleFrequency {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
}

export interface QueueAdditionalSettings {
  avmChannels?: number
  cycleCLID: boolean
  cycleCLIDFrequency: CLIDCycleFrequency | string
  cycleCLIDNumberActive: number | string
  cycleCLIDPreferredProvider?: string
  autoAnswerInbound?: boolean
}

export interface Queue extends JSONApiResourceBase {
  type: 'queues'
  attributes: {
    name?: string
    type?: QueueType
    outboundTrunkGroup?: string
    showClid?: boolean
    flows?: QueueFlows
    additionalConfig?: QueueAdditionalSettings
    createdAt?: string
    updatedAt?: string
  }
  relationships: {
    organization: JSONApiRelation
    inboundCampaign: JSONApiRelation
    users: JSONApiRelationList
    trunks: JSONApiRelationList
  }
}
